module.exports = __webpack_public_path__ + "static/media/review.29f26c5f.svg";